import { useQuery } from "@apollo/client";

import { ResearchTypeSelect_GetAutocompleteOptionsDocument } from "../queries.generated";

export default function useResearchTypeSelect_GetAutocompleteOptions({
    projectIds,
    selectedIds,
}: {
    projectIds?: string[] | null;
    selectedIds?: string[] | null;
}) {
    const { data, previousData, loading } = useQuery(ResearchTypeSelect_GetAutocompleteOptionsDocument, {
        variables: { projectIds: projectIds ?? null },
    });

    const payload = (data ?? previousData)?.settingsResearchTypeGetAutocompleteOptions;
    const options = data?.settingsResearchTypeGetAutocompleteOptions.data ?? [];

    // The endpoint returns the complete set for the current scope, so any selected id missing from it
    // is stale. Only scrub once a successful response is present, so an empty/error response cannot
    // wipe the filter.
    const requestedIds = selectedIds ?? [];
    const resolved = !loading && payload !== undefined;
    const scrubbedSelectedIds = resolved
        ? requestedIds.filter(id => payload.data.some(option => option.value === id))
        : requestedIds;

    // The scrub only ever removes ids, so a length difference means something was dropped.
    const selectedIdsIsScrubbed = scrubbedSelectedIds.length !== requestedIds.length;

    return { options, scrubbedSelectedIds, selectedIdsIsScrubbed, loading };
}
